<div class="container-fluid mt-5">
    <div class="row" *ngIf="!loading">
        <div class="col-md-12">
            <div class="card shadow p-3">
                <div class="card-header border-0">
                    <div class="row align-items-center">
                        <div class="col-12">
                            <h3 class="mb-0">Détails réservation #{{ reservation.id }}</h3>
                        </div>
                    </div>
                    <div class="row align-items-center mt-2">
                        <div class="col-12 text-right">
                            <button type="button" class="btn btn-dark" (click)="back()">
                                <i class="fa fa-angle-left" style="margin: 0 !important;"></i> <span
                                    class="d-none d-lg-inline-block" style="margin-left: 0.5rem;">Retour</span>
                            </button>

                            <button *ngIf="reservation.show_button_cancel" type="button" class="btn btn-outline-danger"
                                (click)="annuler()">
                                <i class="fa fa-times" style="margin: 0 !important;"></i> <span
                                    class="d-none d-lg-inline-block" style="margin-left: 0.5rem;">Annuler</span>
                            </button>


                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <table class="table table-bordered">
                        <tr>
                            <td><strong>Studio : </strong></td>
                            <td>{{ reservation.studio.name }}</td>
                        </tr>
                        <tr>
                            <td><strong>Date de début : </strong></td>
                            <td>{{ date_format(reservation.start_date) }}</td>
                        </tr>
                        <tr>
                            <td><strong>Date de fin : </strong></td>
                            <td>{{ date_format(reservation.end_date) }}</td>
                        </tr>
                        <tr>
                            <td><strong>Nombre d'heures : </strong></td>
                            <td>{{ reservation.nbr_hours_reserved }}H</td>
                        </tr>
                        <tr>
                            <td><strong>Status du réservation : </strong> </td>
                            <td>
                                <span class="{{ status[reservation.status]['class']}}">{{
                                    status[reservation.status]['text']}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Moyen de paiement : </strong></td>
                            <td>{{ reservation.payment_type }}</td>
                        </tr>
                        <tr>
                            <td><strong>Status du paiement : </strong> </td>
                            <td>
                                <span class="{{ status[reservation.payment_status]['class']}}">{{
                                    status[reservation.payment_status]['text']}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Total à payer : </strong></td>
                            <td>{{ reservation.pay }}€</td>
                        </tr>
                        <tr>
                            <td><strong>DATE DE CRÉATION : </strong></td>
                            <td>{{ date_format(reservation.createdAt) }}</td>
                        </tr>

                    </table>
                </div>
            </div>
        </div>
    </div>
</div>